import { render, staticRenderFns } from "./FormCall.vue?vue&type=template&id=cd16a2d4&scoped=true&lang=pug"
import script from "./FormCall.vue?vue&type=script&lang=ts"
export * from "./FormCall.vue?vue&type=script&lang=ts"
import style0 from "./FormCall.vue?vue&type=style&index=0&id=cd16a2d4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd16a2d4",
  null
  
)

export default component.exports